export default "__VITE_ASSET__a530ae0a__"